import { createContext } from 'react';

import {
  EndOfSupportCoverage,
  EndOfSupportRow,
  SortState,
} from '@totem/components/deviceEndOfSupport/types';
import { FilterKey } from '@totem/components/deviceEndOfSupport/utilities';

export type Filters = Partial<Record<FilterKey, string[]>>;

interface Context {
  loading: boolean;
  rows: EndOfSupportRow[];
  // rows after filters, search and sort — what the table shows and the CSV exports
  filteredRows: EndOfSupportRow[];
  coverage: EndOfSupportCoverage | null;
  filters: Filters;
  setFilter: (key: FilterKey, values: string[]) => void;
  search: string;
  setSearch: (search: string) => void;
  sort: SortState;
  setSort: (sort: SortState) => void;
  resetAll: () => void;
  activeTab: string;
  setActiveTab: (tab: string) => void;
  onRefresh: () => void;
}

export default createContext<Context>({
  loading: false,
  rows: [],
  filteredRows: [],
  coverage: null,
  filters: {},
  setFilter: () => {},
  search: '',
  setSearch: () => {},
  sort: { key: null, order: null },
  setSort: () => {},
  resetAll: () => {},
  activeTab: 'devices',
  setActiveTab: () => {},
  onRefresh: () => {},
});
